import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  appBar: {
    padding: 0,
    borderBottom: `1px solid ${theme.palette.background.main}`,
    backgroundColor: "inherit",
    "& .MuiTab-wrapper": {
      fontSize: "70%",
      fontWeight: "bold",
    },
  },
}));
